import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const List = styled.ul`
    padding-left: 24px;
    list-style: disc;
    color: ${COLORS.TextWhite};
    ${FONTS.XXS};

    span {
        display: block;
    }
`;
